<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
        <TaskDescButton></TaskDescButton>
      </el-breadcrumb>
    </div>
    <order-search @onSearch="onSearch"
                  :showPlatformSearch="true"
                  show-addto-taskgroup-target-num
                  :searchValue="search"
    ></order-search>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="showExportDialog"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   size="mini"
                   @click="showExportDialog">批量导出
        </el-button>
        <el-button style="margin-left: 10px;"
                   type="primary"
                   size="mini"
                   @click="showExportSearchDialog">按搜索结果导出
        </el-button>

        <order-batch-succeed-button :multipleSelection="multipleSelection"
                                    style="margin-left: 10px;"
                                    @batch-succeed="batchSucceed">
          批量通过
        </order-batch-succeed-button>
        <el-button type="primary"
                   v-permission="265"
                   size="mini"
                   @click="showExportSneakSimilarityDialog">前置抓拍对比导出
        </el-button>
        <el-button type="danger"
                   v-if="users.usertype + '' === '1'"
                   size="mini"
                   @click="onExportLowScoreFaceImg">人脸识别分值导出
        </el-button>
        <el-button type="danger"
                   v-permission="268"
                   size="mini"
                   @click="showExchangeOrderDialog">交换工单数据
        </el-button>

        <template v-if="search.batchid.length > 0">
          <el-tooltip :disabled="getFirstSearchBatchId() > 0"
                      content="请确保搜索条件中的 项目、批次 的已选条目个数均为 1 个"
                      placement="top"
                      effect="dark">
            <span>
              <order-on-batch-check-button :batchid="getFirstSearchBatchId()"
                                           style="margin-left: 10px;">
                按批次审核
              </order-on-batch-check-button>
              <order-on-batch-succeed-button :batchid="getFirstSearchBatchId()"
                                             style="margin-left: 10px;">
                按批次通过
              </order-on-batch-succeed-button>
              <order-on-batch-withdraw-button :batchid="getFirstSearchBatchId()"
                                              style="margin-left: 10px;">
                按批次收回
              </order-on-batch-withdraw-button>
            </span>
          </el-tooltip>
        </template>

        <el-tooltip content="请确保搜索条件中的 项目 的已选条目个数为 1 个"
                    v-if="search.projectid.length > 0 && search.userid > 0"
                    :disabled="getFirstSearchProjectId() > 0"
                    placement="top"
                    effect="dark">
          <el-button style="margin-left: 10px;"
                     :disabled="getFirstSearchProjectId() < 1"
                     type="primary"
                     size="mini"
                     @click="showAllowanceDialog">执行补贴
          </el-button>
        </el-tooltip>

      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                @sort-change="sortChange"
      >
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column prop="orderid"
                         width="116px"
                         label="工单ID"
        >
          <template slot-scope="scope">
            ORD{{scope.row.orderid}}
          </template>
        </el-table-column>
        <el-table-column prop="title"
                         label="任务标题"
        >
          <template slot-scope="scope">
            <router-link :to="'/order/detail/'+scope.row.orderid"
                         style="text-decoration:none">
              <span style="color:rgb(88,157,248);">{{scope.row.title}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="type"
                         label="任务类型"
                         width="51px"
        >
          <template slot-scope="scope">
          <span v-for="item in options.allType"
                v-if="scope.row.type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_app_type" label="签到平台"  :formatter="formatPlatform"></el-table-column>
        <el-table-column prop="finish_app_type" label="提交平台" :formatter="formatPlatform"></el-table-column>
        <el-table-column prop="userid"
                         label="完成人"
                         width="84px"
                         v-if="parseInt(users.usertype) !== 3">
          <template slot-scope="scope">
            <router-link :to="'/users/table?keyword='+scope.row.userid"
                         v-if="scope.row.userid !== 0"
                         style="text-decoration:none">
              <span style="color:rgb(88,157,248);">{{scope.row.userid}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column  prop="salary"
                         label="赏金"
                         width="65px"
        >
          <template slot-scope="scope">
            {{salaryValue(scope.row.salary)}}
          </template>
        </el-table-column>
        <el-table-column label="任务时间"
                         width="94px"
        >
          <template slot-scope="scope">
            {{scope.row.starttime}}<br/>{{scope.row.endtime}}
          </template>
        </el-table-column>
        <el-table-column label="城市"
                         width="162px"
        >
          <template slot-scope="scope">
            {{scope.row.provincename}}{{scope.row.cityname}}{{scope.row.areaname}}
          </template>
        </el-table-column>
        <el-table-column label="用户提交位置"
                         width="162px"
        >
          <template slot-scope="scope">
            {{scope.row.finish_provincename}}{{scope.row.finish_cityname}}{{scope.row.finish_areaname}}
          </template>
        </el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
        >
          <template slot-scope="scope">
            <router-link :to="'/market/table?id='+scope.row.marketid" target="_blank">
              {{ scope.row.marketname | sjfmarketname(scope.row.type) }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="任务状态"
                         width="92px"
        >
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isInAudit"
                         label="审核状态"
                         width="92px"
        >
          <template slot-scope="scope">
          <span v-for="item in options.isInAudit"
                v-if="scope.row.isInAudit === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="adminname"
                         label="任务发布人"
                         width="94px"
        ></el-table-column>
        <el-table-column prop="customer"
                         label="所属客户"
                         width="84px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.customerid">{{scope.row.customername}}/{{scope.row.customernumber}}</span>
            <span v-if="!scope.row.customerid">平台</span>
          </template>
        </el-table-column>
        <el-table-column prop="review"
                         label="审核次数"
                         sortable="custom"
                         width="52px"
        ></el-table-column>
        <el-table-column label="发布/更新时间"
                         sortable="custom"
                         width="94px"
                         prop="lastupdatetime"
        >
          <template slot-scope="scope">
            {{scope.row.publishtime}}<br/>
            {{scope.row.lastupdatetime}}
          </template>
        </el-table-column>
        <el-table-column label="关闭时限"
                         sortable="custom"
                         width="94px"
                         prop="endtime"
        >
          <template slot-scope="scope">
            {{countDown(scope.row.endtime)}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150px"
        >
          <template slot-scope="scope">
            <OrderOperationButtons :scope="scope"></OrderOperationButtons>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog
        title="导出数据确认"
        :visible.sync="dialogVisible"
        width="45%"
    >
      <div style="font-size: large">共导出{{multipleSelection.length}}条数据</div>
      <el-checkbox class="margin t20"
                   v-model="exportAsync">后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）
      </el-checkbox>
      <el-checkbox class="margin t20"
                   style="margin-left: 0"
                   v-model="convert_midan_task">米单类型任务转为组内任务导出
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onExportPage(0, 1)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">按Dashboard格式导出</el-button>
        <el-button type="primary"
                   @click="onExportPage(1, 0)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">仅导出任务基本数据</el-button>
        <el-button type="primary"
                   @click="onExportPage(0, 0)"
                   :disabled="multipleSelection.length === 0"
                   size="mini">导出任务全部数据</el-button>
        <el-button type="primary"
                   v-if="exportType==='order_new'"
                   icon="el-icon-setting"
                   @click="showExportFieldDialog('page')"
                   :disabled="multipleSelection.length === 0"
                   size="mini">选择导出列</el-button>
        <el-button @click="dialogVisible = false"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="导出数据确认"
        :visible.sync="dialogBatchVisible"
        width="45%"
    >
      <div style="font-size: large">共导出{{pagination.total}}条数据</div>
      <el-checkbox class="margin t20"
                   v-model="exportAsync">后台异步导出（建议1w条数据以上时勾选，勾选后请于批量任务列表确认导出数据）
      </el-checkbox>
      <el-checkbox class="margin t20"
                   style="margin-left: 0"
                   v-model="convert_midan_task">米单类型任务转为组内任务导出
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onExportSearch(0, 1)"
                   :disabled="pagination.total === 0"
                   size="mini">按Dashboard格式导出</el-button>
        <el-button type="primary"
                   @click="onExportSearch(1, 0)"
                   :disabled="pagination.total === 0"
                   size="mini">仅导出任务基本数据</el-button>
        <el-button type="primary"
                   @click="onExportSearch(0, 0)"
                   :disabled="pagination.total === 0"
                   size="mini">导出任务全部数据</el-button>
        <el-button type="primary"
                   v-if="exportType==='order_new'"
                   icon="el-icon-setting"
                   @click="showExportFieldDialog('search')"
                   :disabled="pagination.total === 0"
                   size="mini">选择导出列</el-button>
        <el-button @click="dialogBatchVisible = false"
                   size="mini">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="选择导出列"
        :visible.sync="dialogExportFieldVisible"
        width="70%"
        append-to-body
    >
      <div class="export-field-actions">
        <el-button type="primary"
                   icon="el-icon-check"
                   size="mini"
                   @click="selectAllExportFields">全选</el-button>
        <el-button icon="el-icon-close"
                   size="mini"
                   @click="clearExportFields">取消全选</el-button>
      </div>

      <el-checkbox-group v-model="exportField" class="export-field-list">
        <el-row :gutter="12">
          <el-col v-for="field in exportFieldOptions"
                  :key="field.key"
                  :span="6">
            <el-checkbox :label="field.key">{{field.label}}</el-checkbox>
          </el-col>
        </el-row>
      </el-checkbox-group>

      <el-checkbox v-model="exportQuestionEvidence">
        所有题目证据
      </el-checkbox>

      <span slot="footer"
            class="dialog-footer">
        <el-button size="mini"
                   @click="dialogExportFieldVisible = false">取消</el-button>
        <el-button type="primary"
                   icon="el-icon-download"
                   size="mini"
                   @click="confirmExportFieldSelection">确认导出</el-button>
      </span>
    </el-dialog>


    <el-dialog title="导出前置抓拍准确率数据确认"
               :visible.sync="dialogSneakSimilarVisible"
               width="30%">
      <div style="font-size: large">共导出{{exportCount}}条数据</div>
      <el-checkbox class="margin t20"
                   style="margin-left: 0"
                   v-model="convert_midan_task">米单类型任务转为组内任务导出
      </el-checkbox>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   :disabled="exportCount === 0"
                   @click="onExportOrderSneakSimilarity()">导出数据</el-button>
        <el-button size="mini"
                   @click="() => { dialogSneakSimilarVisible = false; convert_midan_task = false;}">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="工单数据交换"
               :visible.sync="dialogExchangeOrderVisible"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="40%">
      <el-form :model="exchangeOrderForm"
               ref="exchangeOrderForm"
               label-width="96px"
               size="medium">
        <el-form-item label="工单1 ID"
                      prop="orderid1">
        <el-input v-model="exchangeOrderForm.orderid1"
                  placeholder="请输入工单ID,必须为纯数字,例如 66534128">
        </el-input>
        </el-form-item>
        <el-form-item label="工单2 ID"
                      prop="orderid2">
          <el-input v-model="exchangeOrderForm.orderid2"
                    placeholder="请输入工单ID,必须为纯数字,例如 66534128">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="warning"
                   size="mini"
                   @click="doExchangeOrder()">交换数据</el-button>
        <el-button size="mini"
                   @click="closeExchangeOrderDialog()">取消交换</el-button>
      </span>
    </el-dialog>

    <order-allowance-dialog :visible="dialogAllowanceVisible" :info="allowanceInfo" @closeDialog="dialogAllowanceVisible=false"></order-allowance-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import OrderSearch from '../components/OrderSearch'
import OrderBatchSucceedButton from '../components/buttons/OrderBatchSucceedButton'
import OrderOnBatchSucceedButton from '../components/buttons/OrderOnBatchSucceedButton'
import OrderOnBatchWithdrawButton from '../components/buttons/OrderOnBatchWithdrawButton'
import OrderOnBatchCheckButton from '../components/buttons/OrderOnBatchCheckButton'
import OrderOperationButtons from '@/views/order/components/buttons/OrderOperationButtons'
import TaskDescButton from '@/views/task/components/buttons/TaskDescButton'
import OrderAllowanceDialog from '@/views/order/components/OrderAllowanceDialog'
import { NumberArray } from '@utils/common'

// 这里的 key 必须和后端 ExportOrderNewHandler 的字段 key 一致。
// 不能使用中文标题作为传参值，因为标题可能会随着导出格式或单位发生变化。
const ORDER_EXPORT_FIELD_OPTIONS = [
  { key: 'orderid', label: '工单ID' },
  { key: 'taskid', label: '任务ID' },
  { key: 'title', label: '任务标题' },
  { key: 'type', label: '任务类型' },
  { key: 'salary', label: '赏金' },
  { key: 'dynamic_adjust_salary', label: '调价幅度' },
  { key: 'realsalary', label: '工单结算金额' },
  { key: 'points', label: '零豆' },
  { key: 'validcheckindistance', label: '有效签到距离' },
  { key: 'outrange_times', label: '出签到范围次数' },
  { key: 'interrupted_times', label: '重新签到次数' },
  { key: 'lastupdatetimeadmin', label: '管理员更新时间' },
  { key: 'showtime', label: '任务浏览开始时间' },
  { key: 'starttime', label: '任务上线时间' },
  { key: 'deadline', label: '任务下线时间' },
  { key: 'taskendtime', label: '任务结束时间' },
  { key: 'publishtime', label: '任务发布时间' },
  { key: 'uservietime', label: '用户抢单时间' },
  { key: 'userstarttime', label: '用户开始时间' },
  { key: 'userfinishtime', label: '用户结束时间' },
  { key: 'start_app_type', label: '签到平台' },
  { key: 'finish_app_type', label: '提交平台' },
  { key: 'sec_consumed', label: '做单时长' },
  { key: 'first_order_duration', label: '首次做单时长' },
  { key: 'processingtime', label: '任务完成时限(h)' },
  { key: 'reviewtime', label: '审单时间(d)' },
  { key: 'reviewedtime', label: '审核完成时间' },
  { key: 'adminname', label: '添加管理员' },
  { key: 'first_reviewer', label: '初审管理员' },
  { key: 'content', label: '任务详细描述' },
  { key: 'provinceid', label: '省份' },
  { key: 'cityid', label: '城市' },
  { key: 'areaid', label: '地区' },
  { key: 'marketid', label: '任务所属商场' },
  { key: 'marketaddress', label: '门店地址' },
  { key: 'taskmarketareaid', label: '任务所在区域' },
  { key: 'photo', label: '任务照片' },
  { key: 'photocert', label: '任务完成后照片证据' },
  { key: 'checkinlongitude', label: '任务签到经度' },
  { key: 'checkinlatitude', label: '任务签到纬度' },
  { key: 'finishlongitude', label: '任务完成后经度' },
  { key: 'finishlatitude', label: '任务完成后纬度' },
  { key: 'hirenum', label: '需要人数' },
  { key: 'customerid', label: '客户编号' },
  { key: 'projectid', label: '项目编号' },
  { key: 'batchid', label: '批次名称/ID' },
  { key: 'templateid', label: '分步模板ID' },
  { key: 'userid', label: '完成人ID' },
  { key: 'gpsCheck', label: 'GPS位置验证' },
  { key: 'superuserprior', label: '是否白金用户优先' },
  { key: 'rejecttaskrepeat', label: '退单后任务可重复执行' },
  { key: 'rejectuserrepeat', label: '退单后用户可修改' },
  { key: 'priority', label: '是否置顶' },
  { key: 'multitimes', label: '是否可以多次接单' },
  { key: 'onlynearby', label: '是否不在任务大厅显示' },
  { key: 'review', label: '审核次数' },
  { key: 'errormessage', label: '任务审核不通过原因' },
  { key: 'strstatus', label: '任务状态' },
  { key: 'appointuserid', label: '定向用户' },
  { key: 'whitelist', label: '白名单' },
  { key: 'whitelisttags', label: '白名单标签' },
  { key: 'blacklist', label: '黑名单' },
  { key: 'blacklisttags', label: '黑名单标签' },
  { key: 'ostype', label: '发布平台' },
  { key: 'platformtype', label: '发布App' },
  { key: 'minclientversionforandroid', label: '安卓客户端最低版本' },
  { key: 'minclientversionforios', label: 'IOS客户端最低版本' },
  { key: 'minclientversionforandroid_clb', label: '查理宝安卓客户端最低版本' },
  { key: 'minclientversionforios_clb', label: '查理宝IOS客户端最低版本' },
  { key: 'reviewerid', label: '审核管理员' },
  { key: 'total_order_audit_duration', label: '审单时长' },
  { key: 'devicenum', label: '设备号' },
  { key: 'use_servercache', label: '服务器缓存' },
  { key: 'personface_verify', label: '人脸验证' },
  { key: 'face_verified_times', label: '人脸验证次数' },
  { key: 'img_count', label: '照片总数' },
  { key: 'need_full_workinfo', label: '限已完善职业信息用户抢单' },
  { key: 'sneak_photos', label: '前置镜头抓拍' },
  { key: 'vie_source', label: '抢单渠道' },
  { key: 'rank_score', label: '打分分数' },
]

export default {
  mixins: [table],
  components: {
    OrderSearch,
    OrderBatchSucceedButton,
    OrderOnBatchSucceedButton,
    OrderOnBatchWithdrawButton,
    OrderOnBatchCheckButton,
    OrderOperationButtons,
    TaskDescButton,
    OrderAllowanceDialog
  },
  data () {
    return {
      table: [],
      exportType: this.$route.query.export_type || 'order_new',
      multipleSelection: [],
      dialogVisible: false,
      dialogBatchVisible: false,
      dialogAllowanceVisible: false,
      dialogSneakSimilarVisible: false,
      dialogExchangeOrderVisible: false,
      dialogExportFieldVisible: false,
      exportFieldTarget: '',
      exportFieldOptions: ORDER_EXPORT_FIELD_OPTIONS,
      // 默认全选基础字段，用户可以在弹窗中取消不需要的字段。
      // 这样不会因为误确认空数组而触发后端的旧版全量导出。
      exportField: ORDER_EXPORT_FIELD_OPTIONS.map(field => field.key),
      // 题目证据沿用旧版 only_basic 开关，不作为普通 exportField 传递。
      exportQuestionEvidence: false,
      exportCount: 0,
      search: {
        reactive_by_user: null,
        platformtype: null, // 平台类型
        onlineRange: [],
        offlineRange: [],
        reformat: 1,
        start_begin: null,
        start_end: null,
        endtime_begin: null,
        endtime_end: null,
        customerid: null,
        projectid: [],
        start_app_type: [],
        finish_app_type: [],
        type: null,
        batchid: [],
        status: [],
        templateid: null,
        addto_taskgroup_target_num: null,
        userid: null,
        query_areas: [],
        finish_query_areas: [],
        taskmarketareaid: null,
        marketname: null,
        locked: null,
        text: null,
        review_begin: null,
        review_end: null,
        sort_by_review: null,
        sort_by_lastupdatetime: null,
        sort_by_endtime: null,
        userfinishtime: [],
        first_reviewerid: null,
        taskid: null,
        not_type: [21], // 默认排除 线上检查任务, 即PlanC任务
      },
      // 搜索字段申明
      searchFieldType: {
        type: Number,
        status: Array,
        query_areas: Array,
        finish_query_areas: Array,
        start_app_type: NumberArray,
        finish_app_type: NumberArray,
        locked: Number,
        review_begin: Number,
        review_end: Number,
        taskmarketareaid: Number,
        addto_taskgroup_target_num: Number,
        reactive_by_user: Number,
      },
      exportAsync: false,
      convert_midan_task: false,
      dashboardFormat: false,
      exchangeOrderForm: {
        orderid1: null,
        orderid2: null,
      },
      allowanceInfo: {
        order_ids: [],
        provinceid: 0,
        projectid: 0,
        userid: 0,
        remain_amount: 0
      }
    }
  },
  computed: Vuex.mapState({
    options: state => state.order.options,
    users: state => state.login.user,
  }),
  methods: {
    formatPlatform (row, column, cellValue, index) {
      if (cellValue === 0) {
        return row[column.property === 'start_app_type' ? 'userstarttime' : 'userfinishtime'] ? '爱零工' : ''
      }
      const matchedItem = this.options.app_type_list.find(item => item.value === cellValue)

      // 如果找到了就返回 label，没找到就返回 '未知'
      return matchedItem ? matchedItem.label : '-'
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOrderTable', params)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    batchSucceed () {
      this.$refs.multipleTable.clearSelection()
      this.onSearch()
    },
    sortChange (column, prop, order) {
      let sortBy = 'asc'
      if (column.order === 'descending') {
        sortBy = 'desc'
      }
      if (column.prop === 'review') {
        this.search.sort_by_review = sortBy
      } else if (column.prop === 'lastupdatetime') {
        this.search.sort_by_lastupdatetime = sortBy
      } else if (column.prop === 'endtime') {
        this.search.sort_by_endtime = sortBy
      }
      this.onSearch()
    },
    onExportPage (onlyBasic, dashboardFormat, exportField = []) {
      this.dialogVisible = false
      let multipleIds = {
        orderid: this.multipleSelection.map(item => item.orderid),
        export_type: this.exportType,
        only_basic: onlyBasic,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task,
        exportField,
      }

      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择批量导出一个')
        return false
      }

      if (this.exportAsync) {
        return this.onExportAsync(multipleIds)
      }

      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: multipleIds.orderid.length,
        request: (params) => request('exportOrder', params),
        requestParams: multipleIds,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onExportSearch (onlyBasic, dashboardFormat, exportField = []) {
      this.dialogBatchVisible = false
      let detail = {
        ...this.search,
        only_basic: onlyBasic,
        export_type: this.exportType,
        export_async: this.exportAsync,
        dashboard_format: dashboardFormat,
        convert_midan_task: this.convert_midan_task,
        exportField,
      }

      if (this.exportAsync) {
        return this.onExportAsync(detail)
      }

      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: (params) => request('exportOrder', params),
        requestParams: detail,
        fileType: 'csv',
        type: 'array',
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onExportAsync (detail) {
      return request.common('exportOrder', detail).then(() => {
        return this.$message.success('创建成功，请在任务管理中心查看！')
      })
    },
    onExportLowScoreFaceImg () {
      const detail = {...this.search}
      if (detail.projectid.length < 1 && detail.batchid.length < 1) {
        this.$alert('请选择项目或批次后再进行数据导出')
        return
      }

      this.$confirm('确认要导出所有有得分的人脸验证照片吗?', '提示', {type: 'warning'}).then(() => {
        return request.common('exportOrderLowScoreFaceImgApi', detail).then(() => {
          return this.$message.success('任务创建成功，请在任务管理中心查看！')
        })
      })
    },
    showExchangeOrderDialog () {
      this.$set(this, 'exchangeOrderForm', {
        orderid1: null,
        orderid2: null,
      })
      this.dialogExchangeOrderVisible = true
    },
    closeExchangeOrderDialog () {
      this.dialogExchangeOrderVisible = false
    },
    showExportSneakSimilarityDialog () {
      this.exportCount = this.pagination.total
      this.dialogSneakSimilarVisible = true
    },
    countDown (date) {
      let futureTs = (Date.parse(date) + '').substr(0, 10)
      let currentTs = ((new Date()).getTime() + '').substr(0, 10)
      let interval = futureTs - currentTs

      if (interval < 0) {
        return ''
      }

      return filter.formatTimerHumanize(interval)
    },
    showExportDialog () {
      this.dialogVisible = true
      this.exportAsync = false
      this.convert_midan_task = false
    },
    showExportSearchDialog () {
      this.dialogBatchVisible = true
      this.exportAsync = false
      this.convert_midan_task = false
    },
    showExportFieldDialog (target) {
      // 记录用户是从“已选工单”还是“搜索结果”打开字段选择。
      // 确认后会回到对应的导出方法，两个弹窗共用这一套字段选择逻辑。
      this.exportFieldTarget = target
      this.dialogExportFieldVisible = true
    },
    /**
     * 全选导出字段。
     *
     * 通过字段配置重新生成数组，而不是直接复用当前 exportField，
     * 这样无论用户之前取消了哪些字段，点击“全选”后都能恢复完整字段列表。
     */
    selectAllExportFields () {
      this.exportField = this.exportFieldOptions.map(field => field.key)
    },
    /**
     * 取消全选导出字段。
     *
     * 清空 exportField 后，所有字段复选框都会取消选中；
     * 后续点击“确认导出”时会提示用户至少选择一列。
     */
    clearExportFields () {
      this.exportField = []
    },
    confirmExportFieldSelection () {
      if (this.exportField.length === 0) {
        this.$message.error('请至少选择一列导出')
        return
      }

      this.dialogExportFieldVisible = false

      // 勾选“所有题目证据”时，沿用旧版 only_basic=0；
      // 未勾选时使用 only_basic=1，只导出所选基础字段。
      const onlyBasic = this.exportQuestionEvidence ? 0 : 1
      const exportField = this.exportField.slice()

      if (this.exportFieldTarget === 'page') {
        return this.onExportPage(onlyBasic, 0, exportField)
      }

      return this.onExportSearch(onlyBasic, 0, exportField)
    },
    async showAllowanceDialog () {
      let multipleIds = {
        orderid: this.multipleSelection.map(item => item.orderid)
      }
      if (multipleIds.orderid.length <= 0) {
        this.$message.error('请至少选择一个工单')
        return false
      }
      if (!this.multipleSelection.every(v => { return v.provinceid === this.multipleSelection[0].provinceid })) {
        this.$message.error('工单省份不一致')
        return false
      }

      let params = {
        order_ids: multipleIds.orderid,
        provinceid: this.multipleSelection[0].provinceid,
        province_name: this.multipleSelection[0].provincename,
        projectid: this.getFirstSearchProjectId(),
        userid: this.search.userid,
      }
      this.allowanceInfo = params
      await request.common('getExecutiveAllowance', params).then((data) => {
        this.allowanceInfo.remain_amount = data.data ? data.data : 0
      })

      this.dialogAllowanceVisible = true
    },
    salaryValue (value) {
      return filter.hasPermission(250) ? value : '*'
    },
    getFirstSearchProjectId () {
      if (this.search.projectid.length !== 1) {
        return '-1'
      }
      return _.first(this.search.projectid)
    },
    getFirstSearchBatchId () {
      if (this.search.projectid.length !== 1 || this.search.batchid.length !== 1) {
        return '-1'
      }
      return _.first(this.search.batchid)
    },
    onExportOrderSneakSimilarity () {
      const params = {
        ...this.search,
        convert_midan_task: this.convert_midan_task,
      }
      request.common('exportOrderSneakSimilarity', params).then((data) => {
        this.$confirm('抓拍相似度导出任务创建成功，请是否前往批量任务列表中查看?', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/task/batch/table'})
        })
      })
    },
    doExchangeOrder () {
      const params = _.cloneDeep(this.exchangeOrderForm)
      this.$confirm(`确定要交换工单1 (${params.orderid1}) 与工单2 (${params.orderid2}) 的取证数据吗？`, '操作提示', {type: 'info'}).then(() => {
        request.common('allowExchangeOrderApi', params).then(({data}) => {
          // canExchange 是否允许交换，false 代表不允许
          if (data.canExchange === false) {
            // canForceExchange 是否允许强制交换, true 允许强制交换,false 不允许
            // 目前规则下,宴席类的工单在使用模板ID不一致的场景下，允许强制交换数据
            if (data.canForceExchange === true) {
              this.$confirm(`${data.msg}, <strong style="color: red;">确定要继续强制交换工单数据吗？</strong>`, '强制交换数据提示', {type: 'warning', dangerouslyUseHTMLString: true}).then(() => {
                this.callExchangeOrderApi(params)
              }).catch(() => {})
            } else {
              this.$alert(`${data.msg}`, '禁止交换工单', {type: 'error'})
            }
          } else if (data.canExchange === true) {
            this.callExchangeOrderApi(params)
          }
        }).catch(() => {})
      })
    },
    callExchangeOrderApi (params) {
      request.common('exchangeOrderApi', params).then(({data}) => {
        this.$message.success('数据交换成功')
        this.closeExchangeOrderDialog()
      })
    },
  },
}

</script>


<style lang="scss" scoped>
.el-dialog .el-checkbox {
  white-space: normal;
}
.el-dialog .el-checkbox /deep/ .el-checkbox__label {
  display: inline;
}
.export-field-actions {
  margin-bottom: 12px;
}
.export-field-list {
  max-height: 420px;
  overflow-y: auto;
  margin-bottom: 18px;
}
.export-field-list .el-checkbox {
  width: 100%;
  margin: 0 0 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/pages/OrderTable.vue